import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/api.service';
import { ManualUpdateDialogComponent } from '../manual-update-dialog/manual-update-dialog.component';

@Component({
  selector: 'sms-details',
  templateUrl: './sms-details.component.html',
  styleUrls: ['./sms-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SmsDetailsComponent implements OnInit {

  public id = this.route.snapshot.paramMap.get('smsId');
  smsDetails;
  pollOptions;
  showDripdown = false;
  selectedOption;
  optionList =[];
  pollType;
  constructor(private route: ActivatedRoute,
    private dialog: MatDialog,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar
    ) {
  }

  ngOnInit() {
    // this.routeParams.params.subscribe(params => {
    //   this.id = parseInt(params['smsId']);
    // });
    console.log(this.id);
    this.refreshResult();
  }

  refreshResult(){
    this._apiService.getPollResultInfo(this.id).subscribe(res => {
      if (res) {
        console.log(res)
        this.smsDetails = res;
        this._apiService.pollResultsList(res.poll_execute_id).subscribe(res => {
          if (res) {
            this.pollType = res.poll.poll_type;
            this.optionList =[];
            this.pollOptions = res.poll_options;
            for(var i =0; i<this.pollOptions.length; i++){
              this.optionList.push(this.pollOptions[i].name)
           }
            console.log(this.pollOptions)
            console.log(this.optionList)
          }
        },
        (error)=>{
           this._snackBar.open('Error Occured : '+error, 'OK', { duration: 3000 });
        });
      }
   },
   (error)=>{
      this._snackBar.open('Error Occured : '+error, 'OK', { duration: 3000 });
   });
  }

  openEditManualUpdateResult(){
    const dialogRef = this.dialog.open(ManualUpdateDialogComponent, {
      width: '23rem',
      data: {optionList: this.optionList, selectedOption: this.smsDetails.parsed_response, smsDetails:this.smsDetails, pollOptions:this.pollOptions}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.refreshResult();
    });
    
  
  }
 
 
 

}
